<template>
  <form-wrapper :validator="$v">

    <div
      v-for="(item, index) in zahranicne"
      :key="index">
      <zah-item
        v-if="!item.deleted"
        :index="parseInt(index)"
        :zahranicne="zahranicne"
        :odvody="true"
        :druh="druh"
        :kraj="$store.state.zahKraj"
        :kurzy="$store.state.kurzy"
        @del="del(item)"
      />
    </div>

    <buttons
      :add-row="addNewPrijemForm"
      :save="save"
    />

    <financna-link />

  </form-wrapper>
</template>

<script>
import { minValue, maxValue, decimal, requiredIf } from 'vuelidate/lib/validators'
import restEditor from '@/mixins/restEditor'
import zahItem from '@/components/zahItem.vue'
import buttons from '@/components/buttons.vue'
import financnaLink from '@/components/financnaLink.vue'

function zahPar7Data(parent) {
  return {
    deleted: false,
    id: null,
    parent,
    tabulka: 7,
    month: null,
    riadok: 1,
    vz: 'v',
    krajina: '',
    kurz: null,
    prijmy: null,
    vydavky: null,
    odvody: null,
    dan_zaplatena_zahr: null
  }
}

export default {
  validations: {
    zahranicne: {
      $each: {
        deleted: {},
        riadok: {},
        vz: {},
        krajina: {
          required: requiredIf(vm => !vm.deleted)
        },
        kurz: {
          decimal,
          minValue: minValue(0),
          maxValue: maxValue(99999.999)
        },
        prijmy: {
          decimal,
          minValue: minValue(0),
          maxValue: maxValue(99999999.99)
        },
        vydavky: {
          decimal,
          minValue: minValue(0),
          maxValueToPrijmy: (value, vm) =>
            (value ? (parseFloat(value) <= parseFloat(vm.prijmy)) : true)
        },
        odvody: {
          decimal,
          minValue: minValue(0),
          maxValue: maxValue(99999999.99)
        },
        dan_zaplatena_zahr: {
          decimal,
          minValue: minValue(0),
          maxValue: maxValue(99999999.99)
        }
      }
    }
  },

  components: {
    zahItem,
    buttons,
    financnaLink
  },

  mixins: [restEditor],

  data() {
    const parent = this.$route.params.userId
    return {
      parent,
      zahranicne: [zahPar7Data(parent)],
      druh: [
        { value: '1', text: this.$t('message.tuz7r1') },
        { value: '2', text: this.$t('message.tuz7r2') },
        { value: '3', text: this.$t('message.tuz7r3') },
        { value: '4', text: this.$t('message.tuz7r4') },
        { value: '5', text: this.$t('message.tuz7r5') },
        { value: '6', text: this.$t('message.tuz7r6') },
        { value: '7', text: this.$t('message.tuz7r7') },
        { value: '8', text: this.$t('message.tuz7r8') },
        { value: '9', text: this.$t('message.tuz7r9') },
        { value: '10', text: this.$t('message.tuz7r10') },
        { value: '11', text: this.$t('message.lblPrijmyDosiahnute') }
      ],
    }
  },

  methods: {
    async processSave() {
      this.zahranicne.forEach(async (data) => {
        const item = data
        if (item.deleted) {
          // delete existing item
          if (item.id) {
            await this.restDataSource.deleteData(item, 'outland')
          }

          // do not save deleted item
          return;
        }

        if (item.id) {
          await this.restDataSource.updateData(item, 'outland')
        } else {
          item.id = (await this.restDataSource.createData(item, 'outland')).id
        }
      })
      this.zahranicne = this.zahranicne.filter(item => !item.deleted)
    },

    async processGet() {
      const data = await this.restDataSource.getOutland78(7, this.parent)
      if (data.items.length) {
        this.zahranicne = []
      }
      data.items.forEach((item) => {
        const newItem = zahPar7Data(null)

        newItem.id = item.id
        newItem.parent = item.parent
        newItem.tabulka = item.tabulka
        newItem.month = item.month
        newItem.riadok = item.riadok
        newItem.vz = item.vz
        newItem.krajina = item.krajina
        newItem.kurz = item.kurz
        newItem.prijmy = item.prijmy
        newItem.vydavky = item.vydavky
        newItem.odvody = item.odvody
        newItem.dan_zaplatena_zahr = item.dan_zaplatena_zahr

        this.zahranicne.push(newItem)
      });
    },

    addNewPrijemForm() {
      this.zahranicne.push(zahPar7Data(this.parent))
    }

  }
}
</script>

<style>
.p12 .form-check {
    width: 12%;
}
.item-title {
    margin-top: 3.5%;
    text-align: right;
    font-weight: bold;
}
.pull-right {
    float: right;
}
.add-item {
    float: left;
}
.text-muted {
    color: #777;
}
</style>
